export const genderOptions = [
	{ value: 'mal', name: 'Male' },
	{ value: 'fem', name: 'Female' },
];

export const defaultBirthDate = `${
	new Date().getFullYear() - 21
}-12-31T00:00:00Z`;
